var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-runtime-template',{class:{ disabled: _vm.hidden },attrs:{"template":_vm.template}})
}
var staticRenderFns = []

export { render, staticRenderFns }